import {
  type LOW_OTB_DECREASE_PRICE_OPTIONS,
  LOW_OTB_DECREASE_PRICE_REC_TRANSLATION_KEYS,
  type LOW_OTB_NO_PRICE_OPTIONS,
  LOW_OTB_NO_PRICE_REC_TRANSLATION_KEYS,
  NUMBER_OF_DECREASE_PRICE_VARIATIONS,
  NUMBER_OF_NO_PRICE_VARIATIONS,
} from 'lumen/utils/constants/visibility-boost-constants';

/**
 * Randomly returns one translation text of the variations for `low_otb_decrease_price_rec`.
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getTranslationForPriceDecrease() {
  const random = Math.floor(
    Math.random() * NUMBER_OF_DECREASE_PRICE_VARIATIONS,
  ) as LOW_OTB_DECREASE_PRICE_OPTIONS;

  return LOW_OTB_DECREASE_PRICE_REC_TRANSLATION_KEYS[random];
}

/**
 * Randomly returns one translation text of the variations for `low_otb_no_price_rec`.
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getTranslationForNoPriceRecommendation() {
  const random = Math.floor(
    Math.random() * NUMBER_OF_NO_PRICE_VARIATIONS,
  ) as LOW_OTB_NO_PRICE_OPTIONS;

  return LOW_OTB_NO_PRICE_REC_TRANSLATION_KEYS[random];
}
